import { Grid } from '@mui/material';
import React from 'react';
// import MainCard from 'ui-component/cards/MainCard';
import { Box } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import AgentTable from './TableComponent';

const CspTable = (props) => {
  return (
    // <MainCard sx={{ mt: 1 }}>
    <>
      <Grid container justifyContent="flex-start" mb={1}>
        <Grid item md={4}>
          <Grid container spacing={2}>
            <Grid item md={6} xs={12}>
              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth size="small" variant="standard">
                  <InputLabel id="demo-simple-select-label">Status</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={props.table_filter ? props.table_filter.status:'Select'}
                    label="Status"
                    onChange={props.handleChange}
                  >
                    <MenuItem value="Select" disabled>
                      Select Status
                    </MenuItem>
                    <MenuItem value={'Active'}>Active</MenuItem>
                    <MenuItem value={'Inactive'}>Inactive</MenuItem>
                    <MenuItem value={'Blocked'}>Blocked</MenuItem>
                    <MenuItem value={'Replaced'}>Replaced</MenuItem>
                    <MenuItem value={'Deactivated'}>Deactivated</MenuItem>
                    <MenuItem value={'To be replaced'}>To be replaced</MenuItem>
                    <MenuItem value={'Terminate'}>Terminate</MenuItem>
                    <MenuItem value={'Dormant'}>Dormant</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <AgentTable
            ValueEdit={props.ValueEdit}
            setValueEdit={props.setValueEdit}
            Isloading={props.Isloading}
            UserList={props.UserList}
            refunction={props.refunction}
            setPage={props.setPage}
            setRowsPerPage={props.setRowsPerPage}
            handleView={props.handleView}
          />
        </Grid>
      </Grid>
      </>
    // </MainCard>
  );
};

export default CspTable;
